/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q4Inputs */

const et_faq_q4 = /** @type {(inputs: Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas muuta koduleht 24/7 töötavaks müügimasinaks?`)
};

const en_faq_q4 = /** @type {(inputs: Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I turn my website into a 24/7 sales machine?`)
};

/**
* | output |
* | --- |
* | "How do I turn my website into a 24/7 sales machine?" |
*
* @param {Faq_Q4Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q4 = /** @type {((inputs?: Faq_Q4Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q4Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q4(inputs)
	return en_faq_q4(inputs)
});